// client/src/pages/Splash/Splash.jsx
import React, { useEffect } from "react";
import "./Splash.css";

const Splash = () => {
  useEffect(() => {
    const loadParticlesJS = () => {
      if (window.particlesJS) {
        initializeParticles();
      } else {
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/particles.js@2.0.0/particles.min.js";
        script.onload = initializeParticles;
        document.body.appendChild(script);
      }
    };

    const initializeParticles = () => {
      const isMobile = window.innerWidth <= 768;
      const particleCount = isMobile ? 30 : 50;

      window.particlesJS("particles-js", {
        particles: {
          number: {
            value: 200,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: "#000000",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#000000",
            },
            polygon: {
              nb_sides: 5,
            },
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 120,
            color: "#000000",
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 4,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "repulse",
            },
            onclick: {
              enable: true,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 150,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      });

      const countParticles = document.querySelector(".js-count-particles");
      const update = () => {
        if (window.pJSDom && window.pJSDom[0].pJS.particles && window.pJSDom[0].pJS.particles.array) {
          countParticles.innerText = window.pJSDom[0].pJS.particles.array.length;
        }
        requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
    };

    loadParticlesJS();

    return () => {};
  }, []);

  return (
    <div className="splash-container">
      <header className="splash-header">
        <div id="particles-js">
          <h1>GCU Engineering Shop</h1>
        </div>
        <div className="count-particles">
          <span className="js-count-particles">--</span> particles
        </div>
        <section className="capstone-hours">
          <h2>Capstone Hours</h2>
          <p>Monday – Friday: 9am–10pm</p>
          <p>Saturdays: 10am–3pm on these dates:</p>
          <ul>
            <li>Jan 25th</li>
            <li>Feb 8th & 22nd</li>
            <li>Mar 8th & 22nd</li>
            <li>Apr 5th</li>
          </ul>
          <p>Closed Sundays</p>
          <p><strong>Cleanup starts 30 min before closing!</strong></p>
          <p><strong>No projects left overnight!!</strong></p>
          <p><strong>Store in assigned lockers!!</strong></p>
        </section>
      </header>
      <footer className="splash-footer">
        <p>Copyright © 2025 GCU Engineering Shop</p>
        <p><a href="mailto:contact@gcuengineering.com">Paul.Lambertson@gcu.edu</a></p>
        <div className="footer-links">
        </div>
      </footer>
    </div>
  );
};

export default Splash;